@use 'styles/functions/rem' as *;
@use 'styles/mixins/breakpoints' as *;

.selectMenu {
    display: flex;
    flex-direction: column;
    gap: var(--select-input-gap);
    position: relative;
}

.label {
    color: var(--select-input-label-color);
    font-size: var(--select-input-label-font-size);
    font-weight: var(--select-input-label-font-weight);
}

.required {
    color: var(--select-input-required-color);
    margin-left: rem(2px);
}

.trigger {
    align-items: center;
    appearance: none;
    background-color: var(--select-input-background-color);
    border: rem(1px) solid var(--select-input-border-color);
    border-radius: var(--select-input-border-radius);
    color: var(--select-input-color);
    cursor: pointer;
    display: flex;
    font-family: inherit;
    font-size: var(--select-input-font-size);
    justify-content: space-between;
    padding: var(--select-input-trigger-padding);
    text-align: left;
    transition:
        border-color 0.2s ease,
        box-shadow 0.2s ease;
    width: 100%;

    @include mobileAndBelow {
        font-size: var(--select-input-mobile-font-size);
    }
}

.trigger:disabled {
    cursor: not-allowed;
    opacity: var(--select-input-disabled-opacity);
}

.trigger:focus {
    box-shadow: 0 0 0 rem(2px) var(--select-input-focus-box-shadow-color);
    outline: none;
}

.hasError {
    border-color: var(--select-input-error-border-color);
}

.placeholder {
    color: var(--select-input-placeholder-color, var(--select-input-color));
    opacity: 0.6;
}

.chevron {
    align-items: center;
    color: var(--select-input-chevron-color);
    display: flex;
    flex-shrink: 0;
    height: var(--select-input-chevron-size);
    justify-content: center;
    margin-left: rem(8px);
    pointer-events: none;
    transition: transform 0.15s ease;
    width: var(--select-input-chevron-size);
}

.chevronOpen {
    transform: rotate(180deg);
}

.list {
    background: var(--select-input-background-color);
    border: rem(1px) solid var(--select-input-border-color);
    border-radius: var(--select-input-border-radius);
    box-shadow: 0 rem(8px) rem(20px) rgb(0 0 0 / 12%);
    list-style: none;
    margin: 0;
    max-height: rem(280px);
    min-width: 100%;
    overflow-y: auto;
    padding: rem(4px);
    position: absolute;
    top: calc(100% + #{rem(4px)});
    width: var(--select-input-list-width);
    z-index: 50;
}

.option {
    border-radius: var(--select-input-border-radius);
    color: var(--select-input-color);
    cursor: pointer;
    font-size: var(--select-input-font-size);
    padding: var(--select-input-option-padding);
    white-space: var(--select-input-option-white-space);

    @include mobileAndBelow {
        font-size: var(--select-input-mobile-font-size);
    }
}

.option:hover,
.optionFocused {
    background: var(--select-input-focus-box-shadow-color);
}

.optionSelected {
    font-weight: 500;
}

.errorMessage {
    color: var(--select-input-error-color);
    font-size: var(--select-input-error-font-size);
}
